<template>
    <div>
        <div class="modal p-0" tabindex="-1" ref="modal" style="background: #26262657; pointer-events: all; overflow: hidden" @click.self="close">
            <div class="modal-dialog modal-dialog-centered">
                <component v-if="isOpen" :is="pages[store.currentPage]" @nextPage="nextPage"></component>
            </div>
        </div>
    </div>
</template>

<script>
import PanTutorial from "./pages/PanTutorial";
import ZoomTutorial from "./pages/ZoomTutorial";
import SelectTutorial from "./pages/SelectTutorial";
import VueCookie from 'vue-cookie';
import {isMobileDevice} from "../../imageEditor";
import {useMobileTutorialStore} from "./js/store";

export default {
    components: {SelectTutorial, PanTutorial, ZoomTutorial},
    setup() {
        const store = useMobileTutorialStore();

        return {
            store: store,
        }
    },
    data: function () {
        return {
            isOpen: false,
            pages: [
                'PanTutorial',
                'ZoomTutorial',
                'SelectTutorial'
            ]
        }
    },
    mounted() {
        if (!isMobileDevice()) return;

        const tutorialSeen = VueCookie.get('mobileTutorialSeen');
        if (!tutorialSeen) {
            this.open();
            VueCookie.set('mobileTutorialSeen', 'true', { expires: '1y' });
        }
    },
    methods: {
        open() {
            this.isOpen = true;
            this.$nextTick(()=> {
                $(this.$refs.modal).modal({backdrop: false});
            });
        },
        close() {
            $(this.$refs.modal).modal('hide');
            this.isOpen = false;
        },
        nextPage () {
            this.store.currentPage++;

            if (this.store.currentPage > this.pages.length-1) {
                this.close();
                this.store.currentPage = 0;
            }
        }
    }
}
</script>
